import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-cream py-10 md:py-24 px-4 overflow-hidden relative" data-id="element-72">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-73">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold blur-3xl" data-id="element-74"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 rounded-full bg-teal blur-3xl" data-id="element-75"></div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center relative z-10" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-4 md:space-y-8" data-id="element-77">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-teal-dark leading-tight" data-id="element-78">
            Cómo Blindar Tu Espíritu y Recuperar la Paz en Solo 14 Días Sin
            Necesidad de Horas de Estudio
            <span className="block text-2xl md:text-3xl mt-4 text-gold font-normal italic" data-id="element-79">
              — Incluso si Sientes que el Ruido del Mundo te está Robando la Fe
            </span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed" data-id="element-80">
            Descubre el "Protocolo de la Mañana" de 10 minutos que miles de
            personas están usando para conectar con la Eternidad, proteger su
            hogar y despertar con propósito cada día.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex flex-col items-center" data-id="element-81">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-82">
            <img src="https://cdn.magicpatterns.com/uploads/bK1ZdzYg9Ntey2cNnEvmPK/hf_20260319_213341_0b100751-983e-4e2e-93a4-26990d8799b9.png" alt="El Protocolo de la Mañana Ebook en Tablet con café" className="w-full h-auto object-cover" data-id="element-83" />
          </div>
          {/* Decorative element */}
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-teal rounded-full -z-10 opacity-20" data-id="element-84"></div>
          <div className="absolute -top-6 -right-6 w-32 h-32 bg-gold rounded-full -z-10 opacity-20" data-id="element-85"></div>

          <div className="pt-8 w-full text-center" data-id="element-86">
            <CTAButton text="SÍ, QUIERO RECUPERAR MI PAZ HOY" onClick={scrollToPricing} data-id="element-87" />
          </div>
        </motion.div>
      </div>
    </section>;
}